import { trackEvent } from "../../../Actions/Utils";
import "./OptionChips.css"
import { bgColorChips, borderColorChips, textColor } from "../../../NewConstants/OptionConstants";
const OptionChips = ({
  option,
  selectedLanguage,
  send = () => {},
  textSize,
  disabled,
  index,
  selectedChipIndex,
  idx,
  newSession = false,
}) => {
  function saveResponse(input, image) {
    send(index, input, false, image, newSession);
  }
  return (
    <div
      id={`tour-option-chips-${typeof idx !== 'undefined' ? idx : index}`}
      className={`flex items-center justify-start shadow-[0_0_4px_0_#00000040] rounded-xl border border-solid gap-3  min-h-[3.938rem] px-2`}
      onClick={() => {
        saveResponse(option.value[selectedLanguage], option.img);
        trackEvent("Default Chips", "Click", "Default chips from chat");
      }}
      style={{
        fontSize: `${textSize}rem`,
        backgroundColor: selectedChipIndex === index
          ? bgColorChips[option.id - 1]
          : disabled
            ? "var(--neutral-white)"
            : 'var(--neutral-white)',
        opacity: selectedChipIndex === index ? 1 : disabled ? 0.6 : 1,
        border: selectedChipIndex === index
          ? `1px solid ${borderColorChips[option.id - 1]}`
          : disabled
            ? "1px solid var(--border-neutral)"
            : `1px solid ${borderColorChips[option.id - 1]}`,
        color: selectedChipIndex === index ? textColor[option.id - 1]
          : disabled
            ? 'var(--dark-neutral-2)'
            : textColor[option.id - 1],
      }}
    >
      {option.img && <img
          src={option.img}
          alt={option.value[selectedLanguage]}
          className="h-100 w-100 mt-2"
        />}
      <div className="chip-text">
        {option.value[selectedLanguage]}
      </div>
    </div>
  );
};

export default OptionChips;
